import { FormControl, FormErrorMessage } from '@chakra-ui/react';
import { FieldError, Merge, FieldErrorsImpl } from 'react-hook-form';

interface FormFieldProps {
  children: React.ReactNode;
  error?: FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
}

export const FormField = (props: FormFieldProps) => {
  console.info('form-field.tsx_1');

  const { children, error } = props;
  return (
    <FormControl isInvalid={!!error} my={4} width={'auto'}>
      {children}
      {error && typeof error.message === 'string' && (
        <FormErrorMessage>{error.message}</FormErrorMessage>
      )}
    </FormControl>
  );
};
